<h2 mat-dialog-title>Informacion de Posicion</h2>
<mat-dialog-content>
  <app-position-show [elementId]="data.elementId" [element]="data.element" />
</mat-dialog-content>
